
import {
  defineComponent, reactive, computed,
} from 'vue';
import Button from 'primevue/button';
import SegmentationBlockOR from '@/components/segmentations/SegmentationBlockOR.vue';
import { store } from '@/store';
import { useI18n } from 'vue-i18n';
import validateSegmentProperty from '@/components/segmentations/utils/utils';

export default defineComponent({
  name: 'SegmentationBlockAND',
  components: {
    SegmentationBlockOR,
    Button,
  },

  props: {
    blockAnd: {
      type: Array,
      required: false,
      default: () => [],
    },

    indexBlockAnd: {
      type: Number,
      required: true,
    },

    size: {
      type: String,
      required: false,
      default: '',
    },
  },

  setup(props) {
    const { t } = useI18n();
    const dataBlockAND = reactive(props.blockAnd);

    const currentSegmentConfig = computed(() => store.getters['segmentationsEditor/getCurrentSegmentConfig']);
    const paddingSize = computed(() => (props.size === 'small' ? '1' : '2'));

    const addBlockOR = async () => {
      if (currentSegmentConfig.value) {
        const { configProperty: cfg, propertyDefinition: def } = currentSegmentConfig.value;
        if (def?.required && (cfg.data === null || cfg.data === undefined || cfg.data === '' || (Array.isArray(cfg.data) && cfg.data.length === 0))) {
          store.commit('segmentationsEditor/pushError', { type: 'segments', value: { segmentId: cfg.segmentId, value: 'required' } });
          return false;
        }
        const { segmentId } = currentSegmentConfig.value.configProperty;
        const validation = await validateSegmentProperty(currentSegmentConfig.value.configProperty, currentSegmentConfig.value.propertyDefinition);
        if (validation && !validation.success) {
          store.commit('segmentationsEditor/pushError', { type: 'segments', value: { segmentId, value: validation.validate.value } });
          return false;
        }
        store.commit('segmentationsEditor/removeError', { type: 'segments', id: 'segmentId', value: segmentId });
        store.commit('segmentationsEditor/setRefreshContactsNumber', true);
      }
      const { indexBlockAnd } = props;
      store.commit('segmentationsEditor/addBlockOR', indexBlockAnd);
      store.commit('segmentationsEditor/setCurrentSegmentConfig', null);
    };

    const moveBlockOrToBlockAnd = (fromIndexBlockOR: any) => {
      const { indexBlockAnd } = props;
      store.commit('segmentationsEditor/moveBlocksORtoBlockAND', {
        indexBlockAND: indexBlockAnd,
        fromIndexBlockOR,
      });
      store.commit('segmentationsEditor/setRefreshContactsNumber', true);
    };

    return {
      t,
      dataBlockAND,
      paddingSize,
      addBlockOR,
      moveBlockOrToBlockAnd,
    };
  },
});
